module.exports = __webpack_public_path__ + "img/2_5_unit_2.7beed16e.png";